import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const ua = navigator.userAgent || navigator.vendor;


      const isMobileUA =
        /android|iphone|ipad|ipod|windows phone|blackberry|mobile/i.test(ua);


      const isTouchDevice =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;


      const isSmallScreen = window.innerWidth <= breakpoint;


      setIsMobile(isMobileUA && isTouchDevice && isSmallScreen);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [breakpoint]);

  return isMobile;
}
